import { IonContent, IonPage, IonSlide, IonSlides, useIonAlert, useIonToast } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';

import LoadingContainer from '../../../components/loading/LoadingContainer';
import NavButtons from '../../../components/nav-buttons/NavButtons';
import LayoutGap from '../../../layouts/LayoutGap';
import Toolbar from '../../../layouts/Toolbar';
import { DataProvider } from '../../../library/DataProvider';
import { passToWebView } from '../../../library/Funcs';
import { RequestCardPostAction, UserDataAction } from '../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';

import './RequestCard.css';

const RequestCard: React.FC = () => {
    const maxStep = 3;
    const slideOpts = {
        initialSlide: 0,
        allowTouchMove: false,
        speed: 200
    }

    const [alert] = useIonAlert();
    
    const [toast, dismiss] = useIonToast();

    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const dispatch = useAppDispatch()

    const singleUserData = useAppSelector(state => state.userData)
    const { loading, userData } = singleUserData

    const formRequestCard = useAppSelector(state => state.requestCardPost)
    const { form_loading, resp } = formRequestCard

    const [action, setAction] = useState("");

    const [data, setData] = useState({
        cardStatus: "",
        provinces: [],
        avatarImage: "",
        nationalCardImage: "",
        error: false
    });

    const [form1, setForm1] = useState({
        avatar: { value: '', validation: { required: true }, error: "" },
        national_card: { value: '', validation: { required: true }, error: "" }
    });

    const [form2, setForm2] = useState({
        name: { value: "", validation: { required: true }, error: "" },
        family: { value: "", validation: { required: true }, error: "" },
        gender: { value: "", validation: { required: true }, error: "" },
        province: { value: "", validation: { required: true }, error: "" },
        city: { value: "", validation: { required: true }, error: "" },
        national_code: { value: "", validation: { required: true, min: 10, max: 10 }, error: "" },
        address: { value: "", validation: { required: true }, error: "" },
        postal_code: { value: "", validation: { required: true }, error: "" }
    });

    const [form3, setForm3] = useState({
        education_level: { value: "", validation: {}, error: "" },
        field_study: { value: "", validation: {}, error: "" },
        job: { value: "", validation: {}, error: "" },
        martial: { value: "", validation: {}, error: "" },
        website: { value: "", validation: {}, error: "" },
        instagram: { value: "", validation: {}, error: "" },
        other: { value: "", validation: {}, error: "" },
        cooperation: { value: "", validation: {}, error: "" },

        research: { value: "", validation: {}, error: "" },
        public_relations: { value: "", validation: {}, error: "" },
        religious: { value: "", validation: {}, error: "" },
        developmental: { value: "", validation: {}, error: "" },
        graphics: { value: "", validation: {}, error: "" },
        veterinary: { value: "", validation: {}, error: "" },
        ladies: { value: "", validation: {}, error: "" },
        children: { value: "", validation: {}, error: "" },
        legal: { value: "", validation: {}, error: "" },
        documentation: { value: "", validation: {}, error: "" }
    });

    const [form4, setForm4] = useState({
        aid_amount: { value: "", validation: { required: true, min_amount: 50000 }, error: "" },
        aid_obligation: { value: "", validation: { checkbox_required: true }, error: "" }
    });

    const [formProvider1] = useState(() => new DataProvider(form1, setForm1));
    const [formProvider2] = useState(() => new DataProvider(form2, setForm2));
    const [formProvider3] = useState(() => new DataProvider(form3, setForm3));
    const [formProvider4] = useState(() => new DataProvider(form4, setForm4));

    const form1SubmitHandler = () => {
        let formValidation = formProvider1.validation(form1);

        if (form1.avatar.value.length == 0) {
            toast({ message: "لطفا تصویر پروفایل خود را ثبت نمایید.", duration: 2000, color: "warning" })
        } else if (form1.national_card.value.length == 0) {
            toast({ message: "لطفا تصویر کارت ملی خود را ثبت نمایید.", duration: 2000, color: "warning" })
        }

        return formValidation;
    }

    const form2SubmitHandler = () => {
        let formValidation = formProvider2.validation(form2);

        return formValidation;
    }

    const form3SubmitHandler = () => {
        let formValidation = formProvider3.validation(form3);

        return formValidation;
    }

    const form4SubmitHandler = () => {
        let formValidation = formProvider4.validation(form4);

        return formValidation;
    }

    const nextClickHandler = (step: any) => {
        switch (step) {
            case 0:
                if (!form1SubmitHandler()) return false;
                break;
            case 1:
                if (!form2SubmitHandler()) return false;
                break;
            case 2:
                if (!form3SubmitHandler()) return false;
                break;
            case 3:
                if (!form4SubmitHandler()) return false;
                break;
        }

        return true;
    }

    const requestCardHandler = (action: string) => {
        setAction(action);

        if (form1SubmitHandler() && form3SubmitHandler() && form3SubmitHandler() && form4SubmitHandler()) {
            dispatch(RequestCardPostAction(action,
                form2.name.value, form2.family.value, form2.gender.value, form2.province.value, form2.city.value, form2.national_code.value, form2.address.value, form2.postal_code.value, form3.education_level.value, form3.field_study.value, form3.job.value, form3.martial.value, form3.website.value, form3.instagram.value, form3.other.value, form3.cooperation.value, form3.research.value, form3.public_relations.value, form3.religious.value, form3.developmental.value, form3.graphics.value, form3.veterinary.value, form3.ladies.value, form3.children.value, form3.legal.value, form3.documentation.value, form4.aid_amount.value.replace(/\D+/g, '')
            ))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    if (action == "pay") {
                        passToWebView("sendPayment", resp.url);
                    } else {
                        toast({ message: resp.message, duration: 2000, color: "primary" })
                    }
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    useEffect(() => {
        dispatch(UserDataAction());
    }, [dispatch])

    useEffect(() => {
        if (userData != null && !loading) {
            const form1Data = { ...form1 };
            const form2Data = { ...form2 };
            const form3Data = { ...form3 };
            const form4Data = { ...form4 };

            if (userData.avatar)
                form1Data.avatar.value = userData.avatar_path!;
            if (userData.national_card)
                form1Data.national_card.value = userData.national_card_path!;
            setForm1(form1Data);

            form2Data.name.value = userData.name!;
            form2Data.family.value = userData.family!;
            form2Data.gender.value = userData.gender!;
            form2Data.province.value = userData.province!;
            form2Data.city.value = userData.city!;
            form2Data.address.value = userData.address!;
            form2Data.postal_code.value = userData.postal_code!;
            form2Data.national_code.value = userData.national_code!;
            setForm2(form2Data);

            form3Data.martial.value = userData.martial!;
            form3Data.education_level.value = userData.education_level!;
            form3Data.field_study.value = userData.field_study!;
            form3Data.job.value = userData.job!;
            form3Data.website.value = userData.website!;
            form3Data.instagram.value = userData.instagram!;
            form3Data.other.value = userData.other!;
            form3Data.cooperation.value = userData.cooperation!;

            form3Data.research.value = userData.teams?.research!;
            form3Data.public_relations.value = userData.teams?.public_relations!;
            form3Data.religious.value = userData.teams?.religious!;
            form3Data.developmental.value = userData.teams?.developmental!;
            form3Data.graphics.value = userData.teams?.graphics!;
            form3Data.veterinary.value = userData.teams?.veterinary!;
            form3Data.ladies.value = userData.teams?.ladies!;
            form3Data.children.value = userData.teams?.children!;
            form3Data.legal.value = userData.teams?.legal!;
            form3Data.documentation.value = userData.teams?.documentation!;
            setForm3(form3Data);

            form4Data.aid_amount.value = userData.aid_amount!;
            form4Data.aid_obligation.value = userData.aid_obligation!;
            setForm4(form4Data);

            setData({
                cardStatus: userData.card_status,
                provinces: userData.provinces,
                avatarImage: userData.avatar_path,
                nationalCardImage: userData.national_card_path,
                error: userData.errors !== undefined,
            })

            if (userData.errors !== undefined) {
                alert({
                    header: "توجه",
                    message: userData.errors.join("\n"), buttons: [
                        { text: 'متوجه شدم' },
                    ]
                });
            } else if (userData.card_status == 'returned') {
                if (userData.returned_reasons) {
                    alert({
                        header: "توجه",
                        message: userData.returned_reasons, buttons: [
                            { text: 'متوجه شدم' },
                        ]
                    });
                }
            }
        }
    }, [loading])

    return <LoadingContainer loading={loading}>
        <IonPage className="request-card">
            <Toolbar title="کارت حامی طبیعت" hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <IonSlides ref={sliderRef} options={slideOpts}>
                    <IonSlide>
                        <Section1 formProvider={formProvider1} defaultProfile={data.avatarImage} defaultNationalCard={data.nationalCardImage} />
                    </IonSlide>
                    <IonSlide>
                        <Section2 formProvider={formProvider2} cardStatus={data.cardStatus} provinces={data.provinces} />
                    </IonSlide>
                    <IonSlide>
                        <Section3 formProvider={formProvider3} />
                    </IonSlide>
                    <IonSlide>
                        <Section4 formProvider={formProvider4} formLoading={form_loading} cardStatus={data.cardStatus} avoidPay={data.error} doneClick={requestCardHandler} />
                    </IonSlide>
                </IonSlides>
            </IonContent>

            <NavButtons slider={sliderRef.current} maxStep={maxStep} nextClick={nextClickHandler} />
        </IonPage>
    </LoadingContainer>;
}

export default RequestCard